import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import CssBaseline from "@mui/material/CssBaseline";
import PersonIcon from "@mui/icons-material/Person";

const Item = (props) => {

  return (
    <React.Fragment>
      <CssBaseline />
      <ListItem
        alignItems="flex-start"
        key={`pregunta-${props.index}-${props.id_pregunta}`}
      >
        <ListItemAvatar>
          <Avatar>
            <PersonIcon />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={props.actual.respuesta} />
      </ListItem>
    </React.Fragment>
  );
};

export default Item;
